import { type Package, PeriodUnit } from "@revenuecat/purchases-js";

const DAYS_IN_UNIT: Record<PeriodUnit, number> = {
  [PeriodUnit.Year]: 365,
  [PeriodUnit.Month]: 30,
  [PeriodUnit.Week]: 7,
  [PeriodUnit.Day]: 1,
};

export const formatPrice = (amount: number, currency: string) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
  }).format(amount);

export const periodDays = (pkg: Package): number | null => {
  const period = pkg.webBillingProduct?.period;
  return period ? period.number * DAYS_IN_UNIT[period.unit] : null;
};

/**
 * What users save from switching `from` -> `to`.
 * It uses day based normalization so it works across any period combination
 */
export const calculateSavings = (
  from: Package | null,
  to: Package | null
): string | null => {
  const fromPrice = from?.webBillingProduct?.price;
  const toPrice = to?.webBillingProduct?.price;
  if (!from || !to || !fromPrice || !toPrice) return null;

  const fromCycleDays = periodDays(from);
  const toCycleDays = periodDays(to);
  if (!fromCycleDays || !toCycleDays || toCycleDays <= fromCycleDays)
    return null;

  const projectedCostMicros =
    (fromPrice.amountMicros / fromCycleDays) * toCycleDays;
  const savedMicros = projectedCostMicros - toPrice.amountMicros;
  if (savedMicros <= 0) return null;

  return formatPrice(savedMicros / 1_000_000, toPrice.currency);
};
